import { CumanUnitId, RuthenianUnitId, UnitId } from "@/data/units";
import { Viewport } from "pixi-viewport";
import { FederatedEvent, Point } from "pixi.js";

export const GameScene = {
    WORLD: 'world',
    CITY: 'city',
    BATTLE: 'battle',
} as const;

// Якщо потрібен тип для використання в коді (аналог назви enum):
export type GameScene = (typeof GameScene)[keyof typeof GameScene];

export const FactionSide = {
    RUTHENIA: 'ruthenia',
    CUMANS: 'cumans',
} as const;

// Якщо потрібен тип для використання в коді (аналог назви enum):
export type FactionSide = (typeof FactionSide)[keyof typeof FactionSide];

export interface UnitEntry {
    id: string;
    unitId: UnitId;
    count: number;
}

export interface MapConfig {
    size: number;
    seed: string;
    hillChance: number;
    obstacleChance: number;
    playerUnits: UnitEntry[];
    enemyUnits: UnitEntry[];
}

export interface WorldUIProps {
    rutheniaUnitIds: RuthenianUnitId[];
    cumanUnitIds: CumanUnitId[];
}

export interface IViewportClickEvent {
  event: FederatedEvent; 
  world: Point;
  screen: Point;
  viewport: Viewport;
}